import React from 'react'
import { Link } from 'react-router-dom'
import "./Sidebar.css"
export default function Sidebar() {
    return (
        <div className="sidebar">
            <ul className="sidebarlist">           
            <li  className="row"><Link to="/admin" className="side-link">Retos</Link></li>
            <li  className="row"><Link to="/admin/usuarios" className="side-link">Usuarios</Link></li>
            <li  className="row"><Link to="/admin/equipos" className="side-link">Equipos</Link></li>
            <li  className="row"><Link to="/admin/configuracion" className="side-link">Configuración CTF</Link></li>
            <li  className="row"><Link to="/admin/aprendizaje" className="side-link">Aprendizaje</Link></li>
            <li  className="row"><Link to="/admin/writeups" className="side-link">Writeups</Link></li>
            <li  className="row"><Link to="/admin/respaldos" className="side-link">Configuración Global</Link></li>
            
            </ul>
        </div>
    )
}

